module.exports = __webpack_public_path__ + "static/media/road-A-photo.c9d609fc.svg";